import { useState, useEffect } from 'react';
import { buildStreetViewUrl } from '../utils/googleMaps';

export default function StreetViewWidget({ address, lat, lng }) {
  const [imgError, setImgError] = useState(false);
  const [loading, setLoading]   = useState(true);

  useEffect(() => {
    setImgError(false);
    setLoading(true);
  }, [address, lat, lng]);

  if (!address && !lat) {
    return (
      <div style={{
        width: '100%', height: '100%', background: 'var(--bg-card)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        flexDirection: 'column', gap: 10
      }}>
        <p style={{ color: 'var(--text-muted)', margin: 0, fontSize: '0.9rem' }}>
          Select a property to see Street View
        </p>
      </div>
    );
  }

  const location = (lat && lng) ? { lat, lng } : address;
  const imgUrl   = buildStreetViewUrl(location);
  const mapQuery = encodeURIComponent(address || `${lat},${lng}`);
  const mapUrl   = `https://www.google.com/maps/search/?api=1&query=${mapQuery}`;

  if (imgError) {
    return (
      <div style={{
        width: '100%', height: '100%', background: 'var(--bg-card)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        flexDirection: 'column', gap: 12
      }}>
        <p style={{ color: 'var(--text-muted)', margin: '0 0 8px', fontSize: '0.9rem', textAlign: 'center' }}>
          No Street View available for this address
        </p>
        <a href={mapUrl} target="_blank" rel="noopener noreferrer" className="btn btn-outline btn-sm">
          View on Google Maps
        </a>
      </div>
    );
  }

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      {loading && (
        <div style={{
          position: 'absolute', inset: 0, background: 'var(--bg-card)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1
        }}>
          <div className="spinner" style={{ width: 32, height: 32 }} />
        </div>
      )}
      <img
        src={imgUrl}
        alt={`Street view of ${address}`}
        style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
        onLoad={() => setLoading(false)}
        onError={() => { setLoading(false); setImgError(true); }}
      />
      {!loading && (
        <div style={{
          position: 'absolute', bottom: 0, left: 0, right: 0,
          background: 'linear-gradient(transparent, rgba(0,0,0,0.75))',
          padding: '28px 16px 14px',
          display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between'
        }}>
          <div>
            <div style={{ fontSize: '0.72rem', color: 'rgba(255,255,255,0.55)', marginBottom: 2 }}>Street View</div>
            <div style={{ fontSize: '0.85rem', color: '#fff', fontWeight: 500 }}>{address}</div>
          </div>
          <a href={mapUrl} target="_blank" rel="noopener noreferrer" style={{
            padding: '6px 12px', background: 'rgba(255,255,255,0.15)',
            backdropFilter: 'blur(6px)', borderRadius: 6, fontSize: '0.8rem',
            color: '#fff', textDecoration: 'none', border: '1px solid rgba(255,255,255,0.2)', fontWeight: 500
          }}>
            Open Maps →
          </a>
        </div>
      )}
    </div>
  );
}
